import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { empty, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { MemberService } from '../services/member.service';

@Injectable({
  providedIn: 'root'
})
export class MemberInfoResolver implements Resolve<any> {
  constructor(private memberService: MemberService){}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.memberService.getMemberInfo().pipe(
      catchError((error) => {
         return empty();
      })
   )
  }
}
